export default "__VITE_ASSET__DsOoZ7Iq__"